
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 177.7 35.1"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M42.8 0H4.6C2 0 0 2 0 4.4v26.3c0 2.4 2 4.4 4.6 4.4h38.2c2.5 0 4.6-2 4.6-4.4V4.4C47.3 2 45.3 0 42.8 0z"}}),_c('path',{attrs:{"fill":"#003168","d":"M30.4 5.2H18.1c-.6 0-1 .5-1 1v22.6c0 .6.5 1 1 1h11.6c11.5 0 12.4-9 12.4-11.5v-1.9c-.4-9.8-8.4-11.2-11.7-11.2zm-1.8 18H25V12h3.8s5.3-.4 5.3 5.4c-.1 5.9-5.5 5.8-5.5 5.8z"}}),_c('path',{attrs:{"fill":"#F04E23","d":"M14.3 11V6.2c0-.6-.5-1-1-1H7.5c-.6 0-1 .5-1 1v7.9l7.8-3.1z"}}),_c('path',{attrs:{"fill":"#003168","d":"M6.5 17v11.9c0 .6.5 1 1 1h5.8c.6 0 1-.5 1-1v-15L6.5 17z"}}),_c('path',{attrs:{"fill":"#003168","d":"M42.8 1.3c1.8 0 3.3 1.4 3.3 3.1v26.3c0 1.7-1.5 3.1-3.3 3.1H4.6c-1.8 0-3.3-1.4-3.3-3.1V4.4c0-1.7 1.5-3.1 3.3-3.1h38.2m0-1.3H4.6C2 0 0 2 0 4.4v26.3c0 2.4 2 4.4 4.6 4.4h38.2c2.5 0 4.6-2 4.6-4.4V4.4C47.3 2 45.3 0 42.8 0z"}}),_c('g',[_c('g',{attrs:{"fill":"#003168"}},[_c('path',{attrs:{"d":"M55.9 29.9V5h4.8v11.9L71.5 5h5v.8L66 16.8 76.6 29v.8h-5.2L60.6 17.1v12.8h-4.7zM88.1 5h6l9.4 23.9v.9h-4.7L96.1 23H85.9l-2.6 6.9h-4.6V29l9.4-24zm-.8 14.3h7.4L91.5 11 91 9.7h-.2l-.4 1.3-3.1 8.3zM115 5h6l9.4 23.9v.9h-4.7L123 23h-10.3l-2.6 6.9h-4.6V29L115 5zm-.8 14.3h7.4l-3.2-8.3-.4-1.4h-.2l-.4 1.4-3.2 8.3zM133.8 29.9V5h11c5 0 8.2 3.3 8.2 7.2 0 3.8-2.5 6.1-5.5 6.8 1.4.5 2.5 1.9 3.4 3.8l2.5 6v.9h-4.7l-2.7-6.1c-1-2.3-2.5-3.6-5.1-3.6h-2.3v9.7h-4.8zm4.7-21v7.5h4.9c2.5 0 4.3-1.4 4.3-3.7 0-2.2-1.5-3.8-4.4-3.8h-4.8zM164.2 29.9V9h-8.7V5h22.2v4H169v20.8h-4.8z"}})])])])
          )
        }
      }
    